import { Autocomplete, FormControl, FormHelperText, FormLabel, TextField } from '@mui/material';
import { FC } from 'react';
import { usStates } from "../../util";

export interface IStateAutocompleteProps {
    error?: boolean;
    fullWidth?: boolean;
    disabled?: boolean;
    required?: boolean;
    value: string;
    onChange: (event, value) => void;
    fieldError?: string;
}

export const StateAutocomplete: FC<IStateAutocompleteProps> = props => {

    const { error, fullWidth, disabled, required, value, onChange, fieldError } = props;

    return (
        <FormControl
            error={error}
            fullWidth={fullWidth}
            disabled={disabled}
            required={required}>
            <FormLabel>State</FormLabel>
            <Autocomplete
                value={value}
                onChange={onChange}
                options={usStates.map((usState) => usState.abbreviation)}
                getOptionLabel={(option) => usStates.find((usState) => usState.abbreviation === option)?.name || ''}
                renderInput={(params) => <TextField {...params} />}
                disabled={disabled}
            />
            <FormHelperText>{fieldError}</FormHelperText>
        </FormControl>
    )

}